import React from 'react';
import { Lightbulb, Users, Shield, Monitor, UserCheck } from 'lucide-react';
import { features } from '../data/mockData';

const iconMap = {
  Lightbulb: Lightbulb,
  Users: Users,
  Shield: Shield,
  Monitor: Monitor,
  UserCheck: UserCheck
};

const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-blue-600">Gyanodeepti</span>?
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            We provide everything your child needs for a strong educational foundation
          </p>
          <div className="w-24 h-1 bg-yellow-400 mx-auto rounded-full mt-4" />
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            const colors = [
              { gradient: 'from-blue-500 to-blue-600', bg: 'bg-blue-50' },
              { gradient: 'from-yellow-500 to-yellow-600', bg: 'bg-yellow-50' },
              { gradient: 'from-green-500 to-green-600', bg: 'bg-green-50' },
              { gradient: 'from-purple-500 to-purple-600', bg: 'bg-purple-50' },
              { gradient: 'from-red-500 to-red-600', bg: 'bg-red-50' }
            ];
            const color = colors[index % colors.length];

            return (
              <div 
                key={feature.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
              >
                <div className={`w-16 h-16 bg-gradient-to-br ${color.gradient} rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
